var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllSkippedTestResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6349 9.97342C12.1217 10.4238 12.1217 11.2119 11.6349 11.6622C11.4103 11.8874 11.1108 12 10.8112 12C10.4743 12 10.1747 11.8874 9.95008 11.6622L6.01872 7.72166L2.04992 11.6622C1.82527 11.8874 1.52574 12 1.22621 12C0.889236 12 0.589704 11.8874 0.365055 11.6622C-0.121685 11.2119 -0.121685 10.4238 0.365055 9.97342L4.29641 5.99531L0.365055 2.05473C-0.121685 1.60438 -0.121685 0.816263 0.365055 0.365911C0.814353 -0.12197 1.60062 -0.12197 2.04992 0.365911L6.01872 4.30649L9.95008 0.365911C10.3994 -0.12197 11.1856 -0.12197 11.6349 0.365911C12.1217 0.816263 12.1217 1.60438 11.6349 2.05473L7.70359 6.03284L11.6349 9.97342Z",
    fill: "#566478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSkippedTestResult);
export default __webpack_public_path__ + "static/media/all-skipped-test-result.a548a625dafdd48528f6afe120ac829b.svg";
export { ForwardRef as ReactComponent };